import React, {FC, ReactElement} from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

//TYPES
export type SubTitleProps = {
  label: string,
  icon: ReactElement
  children?: ReactElement | Array<ReactElement>,
};

const SubTitle: FC<SubTitleProps> = ({icon, label, children}) => {
  return <Stack>
    <Stack direction="row" sx={{gap: 1, alignItems: 'center', minWidth: '100px'}}>
      {icon}
      <Typography variant="overline" sx={styles.subtitle}>{label}</Typography>
    </Stack>
    {children}
  </Stack>;
};
export default SubTitle;

const styles ={
  subtitle: {
    color: 'text.secondary',
    m: 0,
    pb: 0.25,
    lineHeight: '16px'
  }
};
